import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import ButtonIcon from '@/components/button/icon/ButtonIcon.vue';
import { computed, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'TextCopy',
    props: {
        fromElementId: null,
        large: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const icon = computed(() => {
            return props.large ? 'copy' : 'copy-alt';
        });
        const size = computed(() => {
            return props.large ? 'large' : 'medium';
        });
        const root = ref(null);
        const copyText = async function () {
            const currentElement = root.value.$el;
            // If inside a shadow DOW, use shadow root. Othewise use global document.
            const parent = currentElement.getRootNode();
            const sourceElement = parent.getElementById(props.fromElementId);
            const text = sourceElement?.textContent?.trim() ?? '';
            await navigator.clipboard.writeText(text);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ButtonIcon, {
                ref_key: "root",
                ref: root,
                "icon-name": _unref(icon),
                size: _unref(size),
                "data-test-id": "text-copy-btn",
                onClick: copyText
            }, null, 8, ["icon-name", "size"]));
        };
    }
});
